var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3893 12.1014L7.34768 5.0598C7.10817 4.82029 6.9924 4.53687 7.00039 4.20953C7.00837 3.8822 7.13212 3.59878 7.37163 3.35927C7.61114 3.11976 7.89456 3 8.2219 3C8.54923 3 8.83265 3.11976 9.07216 3.35927L16.4252 10.7362C16.6168 10.9278 16.7605 11.1434 16.8563 11.3829C16.9521 11.6224 17 11.8619 17 12.1014C17 12.341 16.9521 12.5805 16.8563 12.82C16.7605 13.0595 16.6168 13.2751 16.4252 13.4667L9.04821 20.8436C8.8087 21.0831 8.52927 21.1989 8.20992 21.1909C7.89057 21.1829 7.61114 21.0592 7.37163 20.8197C7.13212 20.5802 7.01236 20.2967 7.01236 19.9694C7.01236 19.6421 7.13212 19.3586 7.37163 19.1191L14.3893 12.1014Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightM);
export default __webpack_public_path__ + "static/media/arrow-right-m.c92a30984f6319975263eba26a392b2b.svg";
export { ForwardRef as ReactComponent };